import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'volunteering-engagements-tab-2-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-engagements-tab-2.part.html',
})

export class VolunteeringEngagementsTab2Part {
}
